import { API } from "config/API"

export const getManualCashCuts = async (filters) => {
  const response = await API.get("/cash-cuts", {
    params: {
      type_cash_cut__icontains: "Corte de caja manual",
      ordering: "-created_at",
      ...filters,
    },
  })
  return response
}

export const getLastManualCashCut = async () => {
  const response = await API.get("/cash-cuts", {
    params: {
      type_cash_cut__icontains: "Corte de caja manual A",
      ordering: "-created_at",
      per_page: 1,
      offset: 0,
    },
  })
  return response
}

export const getBenefitPerMonth = async (payload) => {
  const response = await API.post("/cash-cuts/get_benefit_per_month", payload)
  return response
}

export const getDailyCashCuts = async (filters) => {
  const response = await API.get("/cash-cuts", {
    params: {
      type_cash_cut__icontains: "Corte de caja diario",
      ordering: "-date",
      ...filters,
    },
  })
  return response
}

export const getMonthlyCashCuts = async (filters) => {
  const response = await API.get("/cash-cuts", {
    params: {
      type_cash_cut__icontains: "Corte de caja mensual",
      ordering: "-date",
      ...filters,
    },
  })
  return response
}

export const getWeeklyCashCuts = async (filters) => {
  const response = await API.get("/cash-cuts", {
    params: {
      type_cash_cut__icontains: "Corte de caja semanal",
      ordering: "-date",
      ...filters,
    },
  })
  return response
}
